/* build v4 */
document.addEventListener('DOMContentLoaded', function() {
  function addClassOnInView(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
      } else {
        entry.target.classList.remove('in-view');
      }
    });
  }
  var observer = new IntersectionObserver(addClassOnInView, { threshold: 0.5 });
  document.querySelectorAll('svg.mountains').forEach(function (item) { observer.observe(item); });
});

/* ============================================================
   Variant picker fix (additive, safe to remove this block).
   When a shopper selects an option value (e.g. a Color) whose
   combination with the currently selected other option (e.g. Size)
   is unavailable -- either because that combination does not exist
   OR because it is sold out -- snap the other option(s) to that
   value's first in-stock variant BEFORE the theme's own change
   handler runs. This keeps the selected variant valid so the gallery
   shows the correct image, Add to Cart resolves, and the theme does
   not flag the chosen swatch as disabled (which would hide it when
   the 'hide sold out variants' setting is on). Capture phase, so it
   does not depend on patching the theme's handler.
   ============================================================ */
(function () {
  function snapVariant(event) {
    var input = event.target;
    if (!input || typeof input.matches !== 'function') return;
    if (!input.matches('input, select')) return;
    var host = input.closest('variant-radios, variant-selects');
    if (!host) return;
    var dataEl = host.querySelector('[type="application/json"]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(data)) return;
    var fieldsets = Array.prototype.slice.call(host.querySelectorAll('fieldset'));
    if (!fieldsets.length) return;
    var opts = fieldsets.map(function (fs) {
      var sel = fs.querySelector('select');
      if (sel) return sel.value;
      var checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });
    var match = data.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
    if (match && match.available) return; // valid and in stock, leave as-is
    var idx = fieldsets.indexOf(input.closest('fieldset'));
    if (idx < 0) idx = 0;
    var desired = opts[idx];
    var target = data.find(function (v) { return v.options[idx] === desired && v.available; })
              || data.find(function (v) { return v.options[idx] === desired; });
    if (!target) return;
    fieldsets.forEach(function (fs, i) {
      var val = target.options[i];
      var sel = fs.querySelector('select');
      if (sel) { sel.value = val; return; }
      var esc = (window.CSS && CSS.escape) ? CSS.escape(val) : val;
      var radio = fs.querySelector('input[value="' + esc + '"]');
      if (radio) radio.checked = true;
    });
  }
  document.addEventListener('change', snapVariant, true);
})();
